import React from 'react';
import {routerStore} from './routerStore';

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
  replace?: boolean;
  innerRef?: React.Ref<HTMLAnchorElement>;
}

export class Link extends React.Component<Props> {
  render() {
    const {to, children, innerRef, ...rest} = this.props;

    return (
      <a href={to} ref={innerRef} onClick={this.handleClick} {...rest}>
        {children}
      </a>);
  }

  handleClick = (event: React.MouseEvent) => {
    if (event.button !== 0 || event.ctrlKey || event.altKey || event.shiftKey)
      return;

    event.preventDefault();
    const {to, replace} = this.props;
    if (replace === true)
      routerStore.redirectTo(to);
    else
      routerStore.navigateTo(to);
  };
}
